import { z } from 'zod';
/**
 * Edição PRO de Notícias: a Manchete lê os feeds públicos do dia e escreve, com
 * palavras próprias, o que importa para a pessoa (cidade, trabalho e assuntos
 * de que ela mais gosta). Do veículo ficam só o nome e o link.
 */
export const NEWS_EDITION_LIMITS = {
    storyText: 600,
    why: 220,
    quick: 200,
    sources: 4,
    sectionStories: 3,
    quickItems: 6,
};
export const NEWS_EDITION_SECTIONS = ['cidade', 'trabalho', 'gosto'];
export const NEWS_EDITION_SECTION_TITLE = {
    cidade: 'Na sua cidade',
    trabalho: 'No seu trabalho',
    gosto: 'Do seu jeito',
};
export const newsEditionSourceSchema = z.object({
    name: z.string().min(1).max(60),
    url: z.url(),
});
export const newsEditionStorySchema = z.object({
    id: z.string().min(1).max(40),
    title: z.string().min(1).max(200),
    text: z.string().min(1).max(NEWS_EDITION_LIMITS.storyText),
    why: z.string().max(NEWS_EDITION_LIMITS.why).nullable(),
    theme: z.string().max(40).nullable(),
    sources: z.array(newsEditionSourceSchema).min(1).max(NEWS_EDITION_LIMITS.sources),
});
export const newsEditionSchema = z.object({
    day: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    generatedAt: z.iso.datetime(),
    opening: z.string().max(240),
    reader: z.object({
        place: z.string().nullable(),
        work: z.string().nullable(),
        topics: z.array(z.string()),
    }),
    lead: newsEditionStorySchema,
    sections: z.array(z.object({
        key: z.enum(NEWS_EDITION_SECTIONS),
        title: z.string(),
        stories: z.array(newsEditionStorySchema).min(1).max(NEWS_EDITION_LIMITS.sectionStories),
    })),
    quick: z
        .array(z.object({
        text: z.string().min(1).max(NEWS_EDITION_LIMITS.quick),
        source: newsEditionSourceSchema,
    }))
        .max(NEWS_EDITION_LIMITS.quickItems),
});
export const newsEditionStateSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('ready'), edition: newsEditionSchema }),
    z.object({ status: z.literal('generating') }),
    z.object({ status: z.literal('locked') }),
    /** Falta a permissão de IA do perfil. */
    z.object({ status: z.literal('consent') }),
    /** A pessoa ainda não ligou a edição (ela usa cidade, trabalho e assuntos). */
    z.object({ status: z.literal('optin') }),
    z.object({ status: z.literal('empty'), reason: z.enum(['no_news', 'no_model']) }),
]);
export const newsEditionSignalSchema = z.object({
    storyId: z.string().min(1).max(40),
    theme: z.string().max(40).nullable(),
    signal: z.enum(['open', 'like']),
});
